/**
 * WI #31500 - HSE Toolbox mobile, QR scan to add an employee to the training
 * Sign In Sheet.
 *
 * The scanned training-record QR encodes the web route
 * `.../public/training-record/{SpartaEmployeeId}`. This pulls the Sparta employee
 * GUID out of that value so it can be resolved to an employee.
 *
 * It is fail-closed: only a value that is a training-record path carrying a real
 * GUID resolves. Anything else (a non-GUID segment, an unrelated QR that merely
 * contains a GUID, empty/garbage) returns null so the scan is reported as
 * invalid rather than resolving the wrong employee (AC4).
 */
const TRAINING_RECORD_GUID =
  /training-record\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})(?:[/?#]|$)/i;

export function parseTrainingRecordEmployeeId(
  scanned: string | null | undefined
): string | null {
  if (!scanned) {
    return null;
  }

  const match = TRAINING_RECORD_GUID.exec(scanned.trim());
  return match ? match[1].toLowerCase() : null;
}
